import { render, staticRenderFns } from "./ScoringControlSelect.vue?vue&type=template&id=34768dba&"
import script from "./ScoringControlSelect.vue?vue&type=script&lang=js&"
export * from "./ScoringControlSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports